function VendorRepo({ GRAPHQL_URL, httpClient }) {
  this.getVendorDetails = ({ year }, { success, failure }) => {
    const query = `query getVendorDetails($year: Int!) {
      getVendorDetails(year: $year) {
        error {
          code
          message
          statusCode
        }
        data {
          year
          mapping {
            appliedRate {
              endDate
              startDate
              value
            }
            createdDate
            discountRate {
              endDate
              startDate
              value
            }
            spendTarget {
              endDate
              startDate
              value
            }
            userView
            username
          }
        }
      }
    }`

    httpClient.request(
      {
        method: 'POST',
        url: GRAPHQL_URL,
        data: {
          query,
          variables: {
            year
          }
        }
      },
      {
        success: (response) => {
          success(response)
        },
        failure: (error) => failure(error)
      }
    )
  }

  this.createVendorDetails = ({ vendor, year }, { success, failure }) => {
    const query = `mutation ($vendor: VendorDiscountDetailsInput!, $year: Int!) {
      createVendorDetails(vendor: $vendor, year: $year) {
        data {
          year
          mapping {
            appliedRate {
              endDate
              startDate
              value
            }
            createdDate
            discountRate {
              endDate
              startDate
              value
            }
            spendTarget {
              endDate
              startDate
              value
            }
            userView
            username
          }
        }
        error {
          code
          message
          statusCode
        }
      }
    }`

    httpClient.request(
      {
        method: 'POST',
        url: GRAPHQL_URL,
        data: {
          query,
          variables: {
            vendor,
            year
          }
        }
      },
      {
        success: (response) => {
          success(response)
        },
        failure: (error) => failure(error)
      }
    )
  }
}

export default VendorRepo
